import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";
import { STATS } from "../site/data";

const Counter = ({ value, suffix }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });
  const [n, setN] = useState(0);

  useEffect(() => {
    if (!inView) return;
    let raf;
    const start = performance.now();
    const dur = 1600;
    const tick = (now) => {
      const p = Math.min((now - start) / dur, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setN(Math.round(eased * value));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, value]);

  return (
    <span ref={ref}>
      {n.toLocaleString()}
      {suffix}
    </span>
  );
};

export const Stats = () => (
  <section data-testid="stats-section" className="bg-primary text-primary-foreground py-28 md:py-40">
    <div className="mx-auto max-w-[1600px] px-6 md:px-10">
      <p className="text-xs font-semibold uppercase tracking-[0.24em] text-accent mb-16">The Impact</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-y-16 gap-x-8">
        {STATS.map((s, i) => (
          <motion.div
            key={s.label}
            data-testid={`stat-${i}`}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: i * 0.1 }}
            className="border-t border-primary-foreground/20 pt-6"
          >
            <div className="font-serif font-light text-6xl md:text-7xl mb-4">
              <Counter value={s.value} suffix={s.suffix} />
            </div>
            <p className="text-primary-foreground/70 text-sm uppercase tracking-[0.14em]">{s.label}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
